import { Pipe, PipeTransform } from '@angular/core';
import { EnumConverter } from '../classes';
import { UPLOAD_STATUS } from '../enums';

@Pipe({
  name: 'uploadStatus'
})
export class UploadStatusPipe extends EnumConverter implements PipeTransform {
  enumeration = UPLOAD_STATUS;
}
